import { c as _c } from "react/compiler-runtime";
import { Stack, Typography, useTheme } from '@mui/material';
import { useCallback } from 'react';
import { CheckCircleIcon } from '@/components/icons/CheckCircleIcon';
import { Stars01Icon } from '@/components/icons/Stars01Icon';
import { COLORS } from '@/styles/tokens/colors';
import { BalanceSheetSuggestionPreset } from './BalanceSheetConfigPanel.suggestions';
interface BalanceSheetConfigSuggestionBubbleProps {
  preset: BalanceSheetSuggestionPreset;
  /** When provided, the bubble is interactive (unapplied state). */
  onApply?: (preset: BalanceSheetSuggestionPreset) => void;
  /** When true, shows a spinner and prevents clicks. */
  disabled?: boolean;
  /** Renders the completed (check-circle) variant instead of the stars icon. */
  completed?: boolean;
}
export function BalanceSheetConfigSuggestionBubble(t0) {
  const $ = _c(22);
  const {
    preset,
    onApply,
    disabled,
    completed
  } = t0;
  const theme = useTheme();
  const isInteractive = !completed && !!onApply;
  let t1;
  if ($[0] !== disabled || $[1] !== isInteractive || $[2] !== onApply || $[3] !== preset) {
    t1 = () => {
      if (!isInteractive || disabled) {
        return;
      }
      onApply?.(preset);
    };
    $[0] = disabled;
    $[1] = isInteractive;
    $[2] = onApply;
    $[3] = preset;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleClick = t1;
  const Icon = completed ? CheckCircleIcon : Stars01Icon;
  const t2 = isInteractive ? handleClick : undefined;
  let t3;
  if ($[5] !== disabled || $[6] !== isInteractive) {
    t3 = isInteractive && {
      cursor: disabled ? "not-allowed" : "pointer",
      opacity: disabled ? 0.6 : 1,
      transition: "all 0.2s ease",
      "&:hover": {
        borderColor: disabled ? COLORS.NAVY[100] : COLORS.NAVY[300]
      }
    };
    $[5] = disabled;
    $[6] = isInteractive;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = {
      py: 1.5,
      px: 2,
      gap: 1.25,
      borderRadius: "16px",
      border: `1px solid ${COLORS.NAVY[100]}`,
      backgroundColor: COLORS.NAVY[50],
      width: "fit-content",
      ...t3
    };
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      color: COLORS.TEAL[600]
    };
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== Icon) {
    t6 = <Icon size={16} sx={t5} />;
    $[11] = Icon;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const t7 = completed ? undefined : theme.palette.text.primary;
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      fontWeight: 500
    };
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== preset.label || $[15] !== t7) {
    t9 = <Typography variant="body-xs" color={t7} sx={t8}>{preset.label}</Typography>;
    $[14] = preset.label;
    $[15] = t7;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t2 || $[18] !== t4 || $[19] !== t6 || $[20] !== t9) {
    t10 = <Stack direction="row" alignItems="center" onClick={t2} sx={t4}>{t6}{t9}</Stack>;
    $[17] = t2;
    $[18] = t4;
    $[19] = t6;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
}